import { render, staticRenderFns } from "./BrokerFirmForm.vue?vue&type=template&id=145a5dae&scoped=true"
import script from "./BrokerFirmForm.vue?vue&type=script&lang=js"
export * from "./BrokerFirmForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145a5dae",
  null
  
)

export default component.exports